/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Consumption_Reference_Period_InfoInputs */



/**
* | output |
* | --- |
* | "Reference period: {period}" |
*
* @param {Consumption_Reference_Period_InfoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_reference_period_info = /** @type {((inputs: Consumption_Reference_Period_InfoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Reference_Period_InfoInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Reference period: ${i?.period}`)
	return /** @type {LocalizedString} */ (`Période de référence : ${i?.period}`)
});